import {
  type JSXElementConstructor,
  type PropsWithChildren,
  type ReactElement,
  Children,
} from 'react';
import { isElement } from 'react-is';

import { isProduction } from '../../../core/utils/is-node-environment.js';

/**
 * DataTableV2DevTools slot definition.
 * You can pass the ReactDevTools from `@tanstack/react-table-devtools` in to enable them.
 * @public
 */
export function DataTableV2DevTools({
  devTools,
}: {
  devTools: JSXElementConstructor<{ table: unknown }>;
}) {
  return null;
}

function isDataTableV2DevTools(child: unknown): child is ReactElement<{
  devTools: JSXElementConstructor<{ table: unknown }>;
}> {
  return isElement(child) && child.type === DataTableV2DevTools;
}

/**
 * Helper function that will find the DevTools slot in the children and
 * return the DevTools.
 * @internal
 */
export function _getDevToolsSlot(
  props: PropsWithChildren,
  // Deliberately type table as unknown to avoid exposing the internal type.
  table: unknown,
) {
  if (isProduction()) {
    return null;
  }

  const devToolsSlot = Children.toArray(props.children).find(
    isDataTableV2DevTools,
  );

  if (devToolsSlot) {
    const DevTools = devToolsSlot.props.devTools;
    if (DevTools) {
      return <DevTools table={table} />;
    }
  }
  return null;
}
